import React from "react";
import { Fab, Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

export default function PATSaveButton(props) {
  const { onClick, disabled, size, tooltipText } = props;

  return (
    <Tooltip title={tooltipText || "Save"}>
      <Fab
        size="small"
        disabled={disabled}
        color="secondary"
        aria-label="edit"
        className={props.className ? props.className : ""}
        onClick={onClick}
      >
        <SaveIcon style={{ fontSize: size }} />
      </Fab>
    </Tooltip>
  );
}
